module.exports = __webpack_public_path__ + "static/media/foyer_2.14323ec7.jpg";